module.exports = __webpack_public_path__ + "03_medium_black.eb798279.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_medium_black.png
// module id = d0U6
// module chunks = 0